module.exports = __webpack_public_path__ + "img/GAME_CARDPAIR1.6b215ff5.jpg";